<template>
  <div class="enterprise-list-page enterprise-list-page--banks">

    <!-- Header Card -->
        <PageHeader icon="fas fa-university">
      <template #title>
        Daftar Jenis Bank {{ clinic_name }}
      </template>
      <template #subtitle>
        Kelola daftar bank mitra pembayaran transaksi klinik
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                @click="$router.push('/masters/banks/add')"
                v-if="btn">
                <i class="fas fa-plus"></i>
                <span>Tambah Bank</span>
              </b-button>
      </template>
    </PageHeader>

    <!-- Component List -->
    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>

            <!-- Filter -->
            <div class="row justify-content-end mt-n3">
              <div class="col-md-3">
                <modern-search-input v-model="filter.name" fluid placeholder="Cari nama bank" @keyup="filterByName" />
              </div>
            </div>

            <!-- Table -->
            <medhop-data-table summary-title="Daftar Jenis Bank"
              striped
              hover
              class="mt-3"
              :items="items"
              :fields="fields"
              :style="'white-space: nowrap'"
              responsive="sm">
              <template #table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.key === 'actions' ? '20%' : '' }" />
              </template>
              <template #cell(actions)='data'>
                <b-button
                  size="sm"
                  class="mr-1 btn-info"
                  v-b-tooltip.hover
                  title="Detail"
                  @click="$router.push({ path: '/masters/banks/detail/' + data.item.id })"><i class="fas fa-eye px-0"></i></b-button>
                <b-button
                  size="sm"
                  class="mr-1 btn-success"
                  v-b-tooltip.hover
                  title="Edit"
                  @click="$router.push({ path: '/masters/banks/edit/' + data.item.id })"
                  v-if="btn"><i class="fas fa-edit px-0"></i></b-button>
                <b-button
                  size="sm"
                  class="btn-danger"
                  v-b-tooltip.hover
                  title="Hapus"
                  @click="deleteData(data.item.id)"
                  v-if="btn"><i class="fas fa-trash px-0"></i></b-button>
              </template>
            </medhop-data-table>
            <b-pagination
              v-if="items.length != 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="mt-4"></b-pagination>
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import { debouncer } from "@/core/modules/Helper.js"
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  name: "List",

  components: {
    Card
  },

  data() {
    return {
      // Filter
      filter: {
        name: ''
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
        },
        {
          key: "description",
          label: "Deskripsi",
          sortable: true,
        },
        { key: "actions", label: "Aksi" },
      ],
      // Table Items
      items: [],
      // user access
      btn: false,
      clinic_name: window.configuration == null ? "Medhop" : window.configuration.clinic_name
    }
  },

  methods: {

    pageOnClick(page) {
      this.currentPage = page
      this.pagination()
    },

    async pagination() {
      let filterParams = `&name=${this.filter.name}`
      let response = await module.paginate('banks', `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`)
      let pagination = response.meta.pagination
      this.totalRows = pagination.total

      let a, b
      b = this.perPage * (this.currentPage - 1) + 1
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a
      }

      this.items = response.data
    },

    filterByName() {
      debouncer(() => {
        this.currentPage = 1
        this.pagination()
      }, 500)
    },

    async deleteData(id) {
      // Delete Data
      let result = await module.delete('banks/' + id)
      // If Deleted
      if (result) {
        this.pagination()
      }
    },

    setActiveButton() {
      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "1802") {
          this.btn = true
        }
      }
    },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Jenis Bank" }])
    // Get Data
    this.pagination()
    this.setActiveButton()
  },

}

</script>
